module.exports = __webpack_public_path__ + "img/map_jian.841dfb16.png";